module.exports = __webpack_public_path__ + "static/img/active8.d7f6cbff.png";